<template>
  <div>
    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
      @onChange="onSearchItemChange"
    ></SearchField>

    <Table
      ref="table"
      :tableHeight="tableHeight"
      :tableData="tableData"
      :cols="cols"
      :page="page"
      :limit="limit"
      :total="total"
      :showIndex="true"
      :btns="btns"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    >
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "hazardmonthly",
      formInline: {},
      formCtrl: [
        {
          label: "检查人：",
          keyName: "checker",
          placeholder: "请填写检查人",
          type: "text",
        },
        {
          label: "月份：",
          keyName: "check_month",
          placeholder: "请选择月份",
          type: "month",
        },
      ],
      cols: [
        { prop: "title", label: "标题", minwidth: 200 },
        { prop: "checker", label: "检查人", minwidth: 120 },
        { prop: "check_date", label: "检查时间", minwidth: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          title: "预览",
          cb: ({ id }) => {
            this.$router.push(`/vehicle/pdf?id=${id}&mode=month`);
          },
        },
        {
          title: "下载",
          img: require("@/assets/img/icon_xz.png"),
          unimg: require("@/assets/img/icon_xz_hover.png"),
          cb: ({ id }) => {
            const a = document.createElement("a");
            a.href = this.IP + "/fleet/hazardmonthly/pdf?mode=download&id=" + id;
            // a.download = name;
            a.click();
          },
        },
      ],
    };
  },
  methods: {},
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.formDialog {
  /deep/ .el-input,
  /deep/ .el-select {
    width: 100%;
  }
}
</style>
